import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
// import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ProposalMoreRequest from '../../../widgets/moreRequest/ProposalMoreRequest'
import MoreRequestStaffEditForm from '../../../widgets/moreRequestStaffEdit/MoreRequestStaffEdit'
import { getSendEditContract } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function MoreRequestStaffEdit() {
  //มีคำร้องขอแก้ไขข้อต้องลงเพิ่มเติม
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSendEditContract(projectVersionId)

      if (
        response?.model?.forms?.requestNote?.sendToGrantee &&
        response?.model?.forms?.requestNote?.noteSendToGrantee?.value
      ) {
        response.model.forms.agreementDetails = {
          title: 'รายละเอียดสำหรับแก้ไข',
          content: response?.model?.forms?.requestNote?.noteSendToGrantee?.value || '',
          datetime: null,
          status: null,
        }
      }

      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schema.forms.agreementDetails} />
        )}

        {schema?.forms?.projectFeedback && (
          <ProposalMoreRequest schema={schema.forms.projectFeedback} />
        )}

        {schema?.forms && (
          <MoreRequestStaffEditForm
            schema={schema.forms}
            onSuccess={() => handleGetSchema(projectId)}
            disableForm={schema.forms.disable}
          />
        )}
      </SidebarProposal>
    </>
  )
}
